import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { getCallId } from "../../Redux/UserSlice";
import { backendApi } from "../../services/service";

const SorryPageAttempt = ({ languageContent }) => {
  const call_id = useSelector(getCallId);
  // const languageContent = useSelector(getLanguageContent);
  const submitApi = async (key, value) => {
    await backendApi(call_id, key, value)
      .then((res) => {
        if (res.data) {
          // setPage("verification");
          console.log(res.data);
        }
      })
      .catch((e) => {
        console.log(e.message);
      });
  };
  useEffect(() => {
    submitApi("error_page", "open");
  }, []);
  return (
    <>
      <img src="./trial_error.png" alt="No image" />
      <p style={{ marginTop: "1rem", fontWeight: "bold", fontSize: "1.2rem" }}>
        {languageContent.error_page.sorry}
      </p>
      <p>
        {languageContent.verification_page.errorMsg1}
        <a href="tel:08068025680">08068025680</a>
        {languageContent.verification_page.errorMsg12}
      </p>
    </>
  );
};

export default SorryPageAttempt;
